import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import * as moment from 'moment';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class OCRService {
  private listener: Subject<any> = new Subject();
  FormIncrementer = 0;
  ocrIncrementer = 0;
  textractInput: any;
  cloud_service_base_url = environment.cloud_service_base_url;
  constructor() {
    // This is intentional
  }
  sendResponse(message: any) {
    this.listener.next(message);
  }

  clearResponse() {
    this.listener.next(undefined);
  }

  getResponse(): Observable<any> {
    return this.listener.asObservable();
  }

  sendForDoucumentAnalysis(_s3_bucket_path) {
    // This is intentional
  }

  prepare_form_data(ocrResponse, formioInputs) {
    const formData = {};
    if (ocrResponse && ocrResponse.forms) {
      const ocrforms = ocrResponse.forms;

      const formLength = formioInputs.length;
      let loopContinue = true;
      while (loopContinue) {
        const selectedInput = formioInputs[this.FormIncrementer];
        this.textractInput = ocrforms[this.ocrIncrementer];
        this.conditionSelectedInput(selectedInput, formData, ocrforms);
        if (formLength <= this.FormIncrementer) {
          loopContinue = false;
        }
      }
    }
    return formData;
  }
  conditionSelectedInput(selectedInput, formData, ocrforms) {
    if (selectedInput.label.trim() == this.textractInput.label.trim()) {
      formData[selectedInput.key] = this.textractInput.value;
      this.FormIncrementer++;
      this.ocrIncrementer++;
    } else if (
      (selectedInput.type == 'radio' || selectedInput.type == 'selectboxes') &&
      (this.textractInput.value == 'SELECTED' || this.textractInput.value == 'NOT_SELECTED')
    ) {
      const formValues = selectedInput.values;
      const selectionValue = {};
      console.log('****');
      this.conditionFormValues(formValues, ocrforms, selectedInput, selectionValue, formData);
      this.FormIncrementer++;
    } else {
      console.log('skipping input', selectedInput.label);
      console.log('ta', this.textractInput);
      if (selectedInput.type != 'radio' && selectedInput.type != 'selectboxes') {
        this.FormIncrementer++;
      }

      this.ocrIncrementer++;
    }
  }
  conditionFormValues(formValues, ocrforms, selectedInput, selectionValue, formData) {
    formValues.every(selecetionElement => {
      this.textractInput = ocrforms[this.ocrIncrementer];
      console.log(this.textractInput.label);
      if (selecetionElement.label == this.textractInput.label) {
        if (this.textractInput.value == 'SELECTED') {
          if (selectedInput.type == 'radio') {
            selectionValue = selecetionElement.value;
          } else {
            selectionValue[selecetionElement.value] = true;
          }
        } else {
          if (selectedInput.type == 'selectboxes') {
            selectionValue[selecetionElement.value] = false;
          }
        }
        console.log('sv', selectionValue);
        formData[selectedInput.key] = selectionValue;
        this.ocrIncrementer++;
      }
      return true;
    });
  }

  prepare_from_data_v1(ocr_response, formioInputs) {
    let formData: any;
    if (ocr_response && ocr_response.forms) {
      ocr_response.forms.forEach(item => {
        if (item.value !== 'SELECTED' && item.value !== 'NOT_SELECTED') {
          const selectedInput = formioInputs.find(input => input.label == item.label);
          formData = this.getSelectedDate(item, selectedInput);
        }
      });
    }
    return formData;
  }

  getSelectedDate(item, selectedInput) {
    const formData = {};
    if (selectedInput && selectedInput.type === 'datetime') {
      const mdate = moment(item.value);
      if (mdate.isValid()) {
        item.value = mdate.format('YYYY-MM-DD');
      } else {
        item.value = null;
      }
      formData[selectedInput.key] = item.value;
    }
    return formData;
  }
}
